import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import axios from "axios";
import erpFetcher from "@/common/fetchErpnextServices";
export var api__returnUploadDocument = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(files, isFinance, orderUUID, document_type) {
    var documents, preSignUrls, fileObjects, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          documents = buildDocumentsForPreSign(files, isFinance, orderUUID, document_type);
          _context.n = 1;
          return getPreSignedUrls(document_type, documents);
        case 1:
          preSignUrls = _context.v;
          fileObjects = files.reduce(function (acc, file, index) {
            acc[(index + 1).toString()] = file;
            return acc;
          }, {});
          _context.p = 2;
          _context.n = 3;
          return uploadFiles(fileObjects, preSignUrls);
        case 3:
          return _context.a(2, documents);
        case 4:
          _context.p = 4;
          _t = _context.v;
          throw new Error("Failed to upload files to aws");
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[2, 4]]);
  }));
  return function api__returnUploadDocument(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var getPreSignedUrls = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(document_type, documents) {
    var apiUrl, res, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          apiUrl = "return-order/get-presigned-url";
          _context2.p = 1;
          _context2.n = 2;
          return erpFetcher().post(apiUrl, {
            document_type: document_type,
            // 1 for odometer, 2 for customer.
            documents: documents
          });
        case 2:
          res = _context2.v;
          return _context2.a(2, res.data.data);
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          throw new Error("Failed to get pre-signed URLs");
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return function getPreSignedUrls(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
var buildDocumentsForPreSign = function buildDocumentsForPreSign(files, isFinance, orderUUID, document_type) {
  var documents = {};
  files.forEach(function (file, index) {
    documents[index + 1] = {
      path: "".concat(isFinance ? 2 : 1, "/").concat(orderUUID, "/").concat(document_type, "-").concat(index + 1),
      extension: file.name.split('.').pop()
    };
  });
  return documents;
};
var uploadFiles = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(fileObjects, presignedUrls) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, Promise.all(Object.keys(fileObjects).map(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(key) {
              var fileObject, presignedUrl, response;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    fileObject = fileObjects[key];
                    presignedUrl = presignedUrls[key];
                    _context3.n = 1;
                    return axios.put(presignedUrl, fileObject, {
                      headers: {
                        "Content-Type": fileObject.type
                      }
                    });
                  case 1:
                    response = _context3.v;
                    if (!(response.status !== 200)) {
                      _context3.n = 2;
                      break;
                    }
                    throw new Error("File upload failed");
                  case 2:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            return function (_x9) {
              return _ref4.apply(this, arguments);
            };
          }())));
      }
    }, _callee4);
  }));
  return function uploadFiles(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();
export var api__createReturnOrder = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
    var apiUrl, res, _error$response, _t3;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          apiUrl = "/return-order/return-order";
          _context5.p = 1;
          _context5.n = 2;
          return erpFetcher().post(apiUrl, data);
        case 2:
          res = _context5.v;
          return _context5.a(2, (res === null || res === void 0 ? void 0 : res.data) || null);
        case 3:
          _context5.p = 3;
          _t3 = _context5.v;
          if (!((_error$response = _t3.response) !== null && _error$response !== void 0 && _error$response.data)) {
            _context5.n = 4;
            break;
          }
          return _context5.a(2, {
            success: false,
            errors: _t3.response.data.errors || {
              general: [_t3.response.data.message || "Unknown error occurred"]
            }
          });
        case 4:
          throw new Error("Failed to request return");
        case 5:
          return _context5.a(2);
      }
    }, _callee5, null, [[1, 3]]);
  }));
  return function api__createReturnOrder(_x0) {
    return _ref5.apply(this, arguments);
  };
}();